import { Select as BaseBluBlocksSelect } from "@bluframe/blublocks"
import styled from "styled-components"

export const BluBlocksSelect = styled(BaseBluBlocksSelect)`
  width: 100%;
`
